

// Constants
const ADMIN_TOKEN_KEY = 'adminToken';
const ADMIN_LAST_ACTIVE = 'adminLastActive';
const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds
const ADMIN_SESSION_KEY = 'isAdminAuthenticated';

// Call this function after a successful login API call
export const loginAdmin = (token, message = "Admin mode activated") => {
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
  sessionStorage.setItem(ADMIN_SESSION_KEY, 'true');
  window.dispatchEvent(new CustomEvent('adminStatusChanged'));
  // The toast is now shown in AdminLoginModal upon success
};

// Call this to log out
export const logoutAdmin = (message = "You have been logged out") => {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
  window.dispatchEvent(new CustomEvent('adminStatusChanged'));
  // The toast is now shown in AdminStatusIndicator or Footer
};

// Use this in components to check if the admin is logged in
export const isAdminLoggedIn = () => {
  return sessionStorage.getItem(ADMIN_SESSION_KEY) === 'true';
};

// Get the stored token
export const getAdminToken = () => {
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
};

// Update last active timestamp
export const updateLastActive = () => {
  sessionStorage.setItem(ADMIN_LAST_ACTIVE, Date.now().toString());
};

// Start monitoring user activity
export const startActivityMonitoring = () => {
  const activityEvents = ['mousedown', 'keypress', 'scroll', 'mousemove', 'touchstart'];
  
  const activityHandler = () => {
    if (isAdminLoggedIn()) {
      updateLastActive();
    }
  };
  
  // Add activity listeners
  activityEvents.forEach(event => {
    document.addEventListener(event, activityHandler, { passive: true });
  });
  
  // Return cleanup function
  return () => {
    activityEvents.forEach(event => {
      document.removeEventListener(event, activityHandler);
    });
  };
};

// Debug function to check auth state
export const debugAdminAuth = () => {
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
  const lastActive = sessionStorage.getItem(ADMIN_LAST_ACTIVE);
  const currentTime = Date.now();
  const timeSinceActive = lastActive ? (currentTime - parseInt(lastActive)) : null;
  
  console.log('Admin Auth Debug:', {
    token,
    lastActive,
    currentTime,
    timeSinceActive,
    timeoutThreshold: INACTIVITY_TIMEOUT,
    isLoggedIn: isAdminLoggedIn()
  });
  
  return {
    token,
    lastActive,
    timeSinceActive,
    isLoggedIn: isAdminLoggedIn()
  };
};

// Make debug function globally accessible for console debugging
if (typeof window !== 'undefined') {
  window.debugAdminAuth = debugAdminAuth;
}